module.exports = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
  ALTERNATE: 'alternate'
}



//////////////////
// WEBPACK FOOTER
// ./~/_image-sprite@1.0.0@image-sprite/src/constants.js
// module id = 13
// module chunks = 0